import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-8 gap-3">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-fire-line text-xl text-accent-500"></i>
              </div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                热度榜单
              </h2>
            </div>
            <p className="text-sm text-foreground-500">实时更新的全网热议话题排行榜</p>
          </div>
        </div>

        <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
          {rankingData.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 md:py-4 cursor-pointer hover:bg-background-50 transition-colors ${
                idx < rankingData.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className={`flex-shrink-0 w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg font-heading font-bold text-sm ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-medium text-foreground-800 truncate hover:text-primary-600 transition-colors">
                  {item.title}
                </p>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                {item.change === 'up' && (
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-arrow-up-line text-primary-500 text-sm"></i>
                  </span>
                )}
                {item.change === 'down' && (
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>
                  </span>
                )}
                {item.change === 'new' && (
                  <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-accent-100 text-accent-800 whitespace-nowrap">NEW</span>
                )}
                <span className="text-sm font-semibold text-foreground-700 whitespace-nowrap">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}